class LoaderService {
  static toggleClass = 'show-loader';
  static setLoading(isLoading: boolean) {
    const loader = document.querySelector('.loader-wrapper') as HTMLDivElement;
    if (isLoading) loader.classList.add(this.toggleClass);
    else loader.classList.remove(this.toggleClass);
  }
}
export default LoaderService;
